<template>
    <main-layout>
        <!--<p>NUM OTAG : {{ otag }}</p>-->
    </main-layout>
</template>

<script>
import Installation from "../../js/models/Installation";
import _ from "lodash";
import swal from "sweetalert2";

export default {
    data(){
        return {

        }
    },
    computed: {
        otag(){
            return this.$route.params.str
        }
    },
    async beforeCreate(){
        try {

            let str = this.$route.params.str;
            let itag = null;
            let itagUse = await Installation.findOnInstall(str, 'i_tag');


            let strValid = true;
            let tab = [];

            if( !_.includes(str, '-')){
                strValid = false
            } else {
                tab = str.split('-');
                if(tab.length !== 2){
                    strValid = false
                }

                //Si premier otag plus grand que 2 chiffre x-xxxxx
                if(tab[0].length > 1){
                    strValid = false
                }

                if(!isNaN(tab[0]) || isNaN(parseInt(tab[1]))){
                    strValid = false
                }

            }

            if(strValid === false) {
                swal('Erreur', 'Ce numéro OTAG Install n\'est pas valide', 'error');
                window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'home' });
                return;
            }


            if(typeof this.$route.params.idInst !== "undefined") {
                itag = await Installation.findOnInstall(parseInt(this.$route.params.idInst), 'id');
            }else{
                itag = await Installation.findOnInstall(str, 'i_tag');
            }

            if(itag === false){
                if(this.$route.params.idDet == 0) {
                    //Scan du menu, existe pas..
                    swal('Erreur', 'Ce numéro OTAG n\'est pas assigné à une installation. <br> Pour assigner à une installation :<br> Détenteurs -> Voir installation -> choisir installation existante ou création.', 'error');
                    window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'home' });

                }else{
                    //creation si on a un idDet
                    this.$router.push({ name: 'new-installation', query: { itag: str }, params: {id: this.$route.params.idDet } });
                }
            }else{
                if(str !== itag.i_tag){
                    if(itagUse !== false){
                        swal('Erreur', 'Ce numéro OTAG install est déjà utilisé', 'error');
                        this.$router.push({ name: 'liste-detenteurs' });
                    }else{
                        await Installation.getInstallation(itag.id)
                            .then(async install => {

                              install.i_tag = str;

                              await Installation.updateInstallation(install)
                            }).then(() => {
                          this.$router.push({ name: 'installation', query: { itag : str, scan:true }, params: {idInst: itag.id, id: itag.detenteur} })
                        })
                    }
                }else{
                    this.$router.push({ name: 'installation', query: { scan: true }, params: {idInst: itag.id, id: itag.detenteur} })
                }
            }
        } catch (err) {
            // findOnInstall rejette si listInstallations est illisible : sans
            // ce filet, beforeCreate s'interrompt avant le moindre swal et
            // l'utilisateur reste sur un ecran vide.
            console.error('Scan OTAG installation : lecture des installations impossible', err);
            swal('Erreur', 'Impossible de lire les installations enregistrées. Réessayez, ou relancez l\'application si le problème persiste.', 'error');
            // Le scan ouvre l'app directement sur cette route : il n'y a alors
            // aucune entree d'historique derriere, et go(-1) ne ferait rien.
            window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'home' });
        }
    }
}
</script>




// WEBPACK FOOTER //
// ScanInstall.vue?4d11705e